import CourseCardList, { CourseCardListProps } from './CourseCardList';

export type { CourseCardListProps };
export default CourseCardList;
